export default __webpack_public_path__ + "static/media/twiga.8804810a.jpg";